import {observer} from 'mobx-react';
import {lazy} from 'react';
import {useMemo} from 'react';
import {usePostHog} from 'posthog-js/react';
import {getParameterByName} from '../../utils/get-query-params';
import {MemberSignupController} from './member-signup-controller';
import {MemberSignupFormData} from './member-signup-interface';
import {MemberSignupRequestImpl} from './member-signup-request';
import {buildMemberSignupPayload} from './member-signup.utils';
import {getDetectedTimezone} from '@utils/timezone';

const SetupMemberSignupPage = lazy(() =>
  import('./member-signup-page').then((module) => ({
    default: module.MemberSignupPage,
  })),
);

const SetupWorkspaceForm = lazy(() =>
  import('./member-signup-form').then((module) => ({
    default: module.MemberSignupForm,
  })),
);

export const installMemberSignupPage = () => {
  const request = new MemberSignupRequestImpl();
  const controller = new MemberSignupController(request);

  const FormComponent = observer(() => {
    const token = getParameterByName('token');
    const detectedTimezone = useMemo(() => getDetectedTimezone(), []);
    const posthog = usePostHog();

    const onSubmit = async (data: MemberSignupFormData) => {
      if (token) {
        const response: any = await controller.memberSignup(
          buildMemberSignupPayload(data),
          token,
        );
        if (response?.user?.id) {
          posthog?.identify(response.user.id, {
            email: response.user.email,
            name: `${response.user.firstName} ${response.user.lastName}`,
            role: response.user.role,
          });
          posthog?.capture('member_signed_up');
        }
        response && window.location.assign('/members/you');
      }
    };

    return (
      <SetupWorkspaceForm
        onSubmit={onSubmit}
        defaultTimezone={detectedTimezone}
      />
    );
  });

  const Page = observer(() => (
    <SetupMemberSignupPage FormComponent={FormComponent} />
  ));

  return {
    Page,
  };
};
